import 'core-js/es6/map';
import 'core-js/es6/set';
import ReactOnRails from 'react-on-rails';
import HomeComponent from '../bundles/components/HomeComponent/HomePageComponent';
import AreasComponent from '../bundles/components/AreasComponent/AreasComponent'
import CountryComponent from '../bundles/components/CountryComponent/CountryComponent';
import CityComponent from '../bundles/components/CityComponent/CityComponent';
import DetailsPageComponent from '../bundles/components/DetailsPageComponent/DetailsPageComponent';
import ErrorPage from '../bundles/components/ErrorPage';
import FAQPage from '../bundles/components/FAQPage/FAQPage';
import AboutUsPage from '../bundles/components/AboutUs/AboutUsPage';
import VirtualTourPage from '../bundles/components/VirtualTourPage/VirtualTourPage';
import ProviderPage from '../bundles/components/ProviderPage/ProviderPage';
import PrivatePolicyPage from '../bundles/components/PrivatePolicyPage/PrivatePolicyPage';
import SuccessOrderPage from '../bundles/components/SuccessOrderPage/SuccessOrderPage';
import appStore from '../redux/store';
import 'bootstrap/dist/css/bootstrap'; // eslint-disable-line import/no-unresolved
import '../stylesheets/index.sass';
import UncompletedOrderFormWrapper from '../bundles/components/UncompletedOrderForm/UncompletedOrderFormWrapper';
import Notification from '../bundles/components/UncompletedOrderNotification/Notification';

// This is how react_on_rails can see the HelloWorld in the browser.
ReactOnRails.register({
  HomeComponent,
  AreasComponent,
  CountryComponent,
  CityComponent,
  DetailsPageComponent,
  AboutUsPage,
  ErrorPage,
  ProviderPage,
  PrivatePolicyPage,
  FAQPage,
  VirtualTourPage,
  SuccessOrderPage,
  UncompletedOrderFormWrapper,
  Notification
});

ReactOnRails.registerStore({
  appStore,
});
